<template>
  <v-text-field
    v-model="inputData"
    background-color="#0000004D"
    solo
    class="alert-text"
    fontWeight="bold"
    dark
    prepend-inner-icon="mdi-information-outline"
    rounded
    :disabled="isEditable"
  ></v-text-field>
</template>

<script>
export default {
  name: "AlertText",
  data: () => ({}),
  methods: {},
  created() {},
  computed: {
    inputData: {
      get() {
        return this.alertText;
      },
      set(value) {
        this.$emit("update:alertText", value);
      }
    }
  },
  components: {},
  props: ["alertText", "isEditable"]
};
</script>

<style scoped>
.alert-text {
  border: none;
  height: 40px;
}
@media screen and (max-width: 350px) {
  .alert-text {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  .alert-text {
    font-size: 1em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
